import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { SwiperSlide } from "swiper/react";

import { theme } from "shared/lib/styles";

import { Swiper } from "scmp-app/components/swiper";

import ArrowNext from "./arrow-next.svg";
import ArrowPrevious from "./arrow-previous.svg";

export const Container = styled.div`
  margin-block: 33px 40px;
  padding-inline: 0;

  ${theme.breakpoints.up("tablet")} {
    margin-block: 40px;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-block: 64px 85px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    margin-block: 93px 85px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  margin-block: 0;
  margin-inline: 16px;
  ${theme.breakpoints.up("tablet")} {
    max-inline-size: 560px;
    margin-inline: auto;
  }
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 968px;
  }
`;

export const StyledSwiper = styled(Swiper)`
  position: relative;

  inline-size: 100%;

  .swiper-button-disabled {
    opacity: 0;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  padding-inline: 36px;
  ${theme.breakpoints.up("tablet")} {
    padding-inline: 40px;
  }
  ${theme.breakpoints.up("desktop")} {
    padding-inline: 64px;
  }
`;

const ArrowStyle = css`
  position: absolute;
  inset-block-start: 50%;
  z-index: 1;

  inline-size: 24px;
  block-size: 24px;

  cursor: pointer;

  transform: translateY(-50%);
`;

export const StyledArrowPrevious = styled(ArrowPrevious)`
  ${ArrowStyle}
  inset-inline-start: 0%;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 40px;
    block-size: 40px;
  }
`;
export const StyledArrowNext = styled(ArrowNext)`
  ${ArrowStyle}
  inset-inline-end: 0;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 40px;
    block-size: 40px;
  }
`;
